<template>
  <div
    class="input-group"
    :class="`input-group-${variant} ${getStatus(error, success)} ${filled}`"
  >
    <label :class="variant === 'static' ? '' : 'form-label'">{{ label }}</label>
    <input
      :id="id"
      v-model="modelValueHandler"
      :autocomplete="autocomplete"
      :type="type"
      class="form-control"
      :class="getClasses(size)"
      :name="name"
      :placeholder="placeholder"
      :required="isRequired"
      :disabled="disabled"
      :max="max"
      :min="min"
    />
  </div>
</template>

<script>
import { createVModelHandlers } from '@/helpers/vue';
import setMaterialInput from "@/assets/js/material-input.js";

export default {
  name: "MaterialInput",
  props: {
    autocomplete: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: "outline",
    },
    label: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [
        Number,
        String,
      ],
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    max: {
      type: [
        String,
        Number,
      ],
      default: '',
    },
    min: {
      type: [
        String,
        Number,
      ],
      default: '',
    },
  },

  emits: [
    'update:modelValue',
  ],

  computed: {
    ...createVModelHandlers(
      'modelValue',
    ),
    
    filled() {
      return !this.error && this.modelValueHandler !== ""
        ? 'is-filled'
        : '';
    }
  },

  mounted() {
    setMaterialInput();
  },
  methods: {
    getClasses: (size) => {
      let sizeValue;

      sizeValue = size ? `form-control-${size}` : null;

      return sizeValue;
    },
    getStatus: (error, success) => {
      let isValidValue;

      if (success) {
        isValidValue = "is-valid";
      } else if (error) {
        isValidValue = "is-invalid";
      } else {
        isValidValue = null;
      }

      return isValidValue;
    },
  },
};
</script>
